import React, { useContext, useEffect, useState } from 'react';
import { addcontext } from '../../ContextShare/ContextShare';
import { useNavigate } from 'react-router-dom';
import language from '../../language.json'

function GridRulings({ getRListData }) {
    const baseUrl = process.env.REACT_APP_BASEURL
    const altimg = process.env.REACT_APP_ALT_IMG;
    const { videoUrl, setVideoUrl } = useContext(addcontext)
    const { videoThumb, setVideoThumb } = useContext(addcontext)
    const { videoData, setVideoData } = useContext(addcontext)
    const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext)
    const navigate = useNavigate()
    const { langChanged, setlangChanged } = useContext(addcontext)
    const [currentLanguage, setCurrentLanguage] = useState();

    useEffect(() => {
        setCurrentLanguage(localStorage.getItem('language') || 'en')
    }, [currentLanguage, langChanged])
    //redirect to video play page
    const handleGovGridClicked = (e) => {
        setVideoUrl(e.video_url)
        setVideoThumb(e.video_thumbnail)
        //  setwhichPageIsSendingData('rulingss')
        setVideoData(e)
        // navigate('/video')
        if (e?.mapping_id) {
            console.log(e?.mapping_id);
            navigate(`/video/:${e?.mapping_id}`);
        }
    }
    return (
        <div className='w-full flex flex-wrap justify-start items-start mt-5'>

            {getRListData?.length > 0 ? getRListData.map((value, index) => (
                <div key={index} className='w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/4 p-4'>
                    <div onClick={(e) => handleGovGridClicked(getRListData[index])} className='h-auto mb-5 border rounded-md shadow hover:shadow-2xl'>
                        <div>
                            <img src={value?.video_thumbnail ? `${baseUrl}${value.video_thumbnail}` : altimg} className='w-full h-52 rounded-t-md' alt="Gov address image" />
                        </div>
                        <div>
                            <h4 className={`${currentLanguage == 'en' ? 'text-lg' : 'text-sm'} mt-2 ms-1 font-semibold`}>{currentLanguage == 'en' ? value?.video_event : value?.malayalam_video_event}</h4>
                        </div>
                        <div className='flex flex-row justify-between'>
                            <h4 className={`${currentLanguage == 'en' ? 'text-sm' : 'text-xs'} ms-1 font-light`}>{currentLanguage == 'en' ? value?.video_member : value?.malayalam_video_member}</h4>
                            <h4 className={`${currentLanguage == 'en' ? 'text-sm' : 'text-xs'} me-3 font-light mb-5`}>{value.video_upload_date}</h4>
                        </div>
                    </div>
                </div>
            ))
                :
                // if no data
                <div className='w-full h-full flex border p-6 justify-center items-center'>There are no records to display</div>


            }

        </div>
    );
}

export default GridRulings;
